/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Work_Activity_File_Too_LargeInputs */

const vi_error_work_activity_file_too_large = /** @type {(inputs: Error_Work_Activity_File_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tệp nặng quá 50 MB. Vui lòng chọn tệp nhỏ hơn.`)
};

/**

* @param {Error_Work_Activity_File_Too_LargeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_work_activity_file_too_large = /** @type {((inputs?: Error_Work_Activity_File_Too_LargeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Work_Activity_File_Too_LargeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_work_activity_file_too_large(inputs)
});